import {Component, Input, OnInit} from '@angular/core';
import {FeedbackDialogComponent} from '../feedback-dialog/feedback-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {SystemsOverviewService} from '../../services/systems-overview.service';
import {UserInformationService} from '../../services/user-information.service';
import {Router} from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../../services/auth.service';
import {delay, map} from 'rxjs/operators';
import {error} from 'protractor';
import {environment} from '../../../environments/environment';
import {MatSnackBar} from '@angular/material/snack-bar';
import {TranslateService} from '@ngx-translate/core';


@Component({
    selector: 'vi-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


    constructor(public dialog: MatDialog, public systemsOverviewService: SystemsOverviewService, private translateService: TranslateService,
                public userInformationService: UserInformationService, public auth: AuthService, private _snackBar: MatSnackBar) {
        this.authenticated$ = this.auth.csrfToken$.pipe(
            delay(10),
            map((token) => {
                return !!token;
            })
        );
    }

    authenticated$: Observable<boolean>;

    ngOnInit(): void {
    }

    openFeedbackDialog() {
        if (this.userInformationService.country === 'AT') {
            window.open(environment.atPartnerPortalSupportLink, '_blank');
        } else if (this.userInformationService.country === 'DE') {
            const dialogRef = this.dialog.open(FeedbackDialogComponent, {
                width: '550px',
                data: {name: 'Feedback', isCaseForm: true}
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.systemsOverviewService.createSupportRequest(result).subscribe((data) => {
                        this._snackBar.open(this.translateService.instant('feedbackdialog.thankyou'), null);
                    });
                }
            }, (error) => {
                this._snackBar.open(this.translateService.instant('feedbackdialog.error'), null);
            });
        } else {
            const dialogRef = this.dialog.open(FeedbackDialogComponent, {
                width: '550px',
                data: {name: 'Feedback', isCaseForm: false}
            });

            dialogRef.afterClosed().subscribe(result => {
                if (result) {
                    this.systemsOverviewService.sendEmail(result).subscribe((data) => {
                        this._snackBar.open(this.translateService.instant('feedbackdialog.thankyou'), null);
                    });
                }
            }, (error) => {
                this._snackBar.open(this.translateService.instant('feedbackdialog.error'), null);
            });
        }
    }

    logout() {
        localStorage.clear();
        this.userInformationService.loggedIn = false;
    }
}
